import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { DialogContent, DialogTitle, Typography } from '@mui/material';
import Modal from '../modal/Modal';
import tooltipModalStyles from './tooltipModal.styles';
const TooltipModal = memo(({ isOpen, id, title, text, onClose }) => {
    const styles = tooltipModalStyles();
    return (_jsxs(Modal, { open: isOpen, labelledBy: id, onClose: onClose, children: [_jsx(DialogTitle, { id: id, children: _jsx(Typography, { "data-test": 'tooltip:title', children: title }, void 0) }, void 0), _jsx(DialogContent, { classes: { root: styles.dialog }, children: _jsx(Typography, { "data-test": 'tooltip:text', children: text }, void 0) }, void 0)] }, void 0));
});
export default TooltipModal;
//# sourceMappingURL=TooltipModal.js.map